import Tippy from '@tippyjs/react';
import { followCursor } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light-border.css';
import './tooltip.scss';
import React, { type ComponentProps } from 'react';

interface TooltipProps extends ComponentProps<typeof Tippy> {
    dangerousInput?: string;
    /** Uses the same rounded, bordered frame as the form fields. */
    rounded?: boolean;
}

function Tooltip({ children, dangerousInput = '', rounded = false, ...rest }: TooltipProps) {
    if (!children) return null;

    if (dangerousInput) rest.content = <div dangerouslySetInnerHTML={{ __html: dangerousInput }} />;

    if (rest.followCursor) {
        rest.plugins = [followCursor, ...(rest.plugins || [])];
    }

    return (
        <Tippy
            theme={rounded ? 'light-border omnidots-rounded' : 'omnidots-white-shadow'}
            {...rest}
        >
            {children}
        </Tippy>
    );
}

Tooltip.displayName = 'Tooltip';

export default Tooltip;
